<template>
	<div class="navbar" :class="{active: pop.active}">
		<div class="leftbox">
			<div class="callerbox" @click="showDlg(4)" v-if="this.callerMsg.phone">
				<!--  v-if="callerMsg.phone" -->
				来电
				<p>
					<span>{{ callerMsg.phone}}</span>
					<i :class="status=='finished'?'el-icon-connection':'el-icon-search'" />
					{{ (status=='finished') ?'绑定患者':'查看'  }}
				</p>
			</div>
			<div class="tipsBox" v-if="tips=='unUsb'||tips=='unServe'">
				{{
					{
						'unUsb':'没有检测到USB盒子设备插入',
						'unServe':'双佰康呼叫软件未开启'
					}[tips]
				}}
			</div>

			<div class="callingBox" v-if="status=='calling'||status=='uploading'">
				{{ {'calling':'通话中,挂机前请勿关闭页面',
					'uploading':'上传文件中请勿关闭页面'
					}[status]
				}}
			</div>
			<div v-if="callstate&&GXcallFlag&&hospitalCode=='ZJ_SC1'" class="clearState" @click="clearState">
				<!-- <span v-if="!endFlag">结束录音</span> -->
				<span>转评价</span>
			</div>
			<div class="smstips" v-if="smsFlag&&this.smsCount?.totalNotSendSms<=10">
				剩余短信条数不足10条，请联系双佰康疾病管理系统工程师充值
			</div>
		</div>
		<div class="rigbox">
			<div class="item link" @click="showDlg(3)"><i class="icon-book"></i><span class="padl5">知识库</span></div>
			<div class="item link">
				<Ring />
			</div>
			<div class="item" @click="togglePop">
				<!-- <el-avatar :size="30"></el-avatar> -->
				<span class="nick" v-text="my.name"></span>
			</div>
			<div class="item more" @click="togglePop"><i class="el-icon-arrow-down"></i></div>
			<div class="pop-mask" @click="togglePop"></div>
			<div class="pop">
				<div><el-link type="primary" :underline="false" @click="showDlg(1)">修改信息</el-link></div>
				<div><el-link type="primary" :underline="false" @click="showDlg(2)">修改密码</el-link></div>
				<div><el-link type="primary" :underline="false" @click="logout">退出登录</el-link></div>
			</div>
			<div class="item logout">
				<el-button type="danger" round  size="small"  @click="logout"><span class="padl5">退出登录</span></el-button>
			</div>
		</div>

		<el-dialog custom-class="relative" title="修改信息" width="500px" center :visible.sync="dlg.active"
			:close-on-click-modal="false">
			<el-form ref="form" size="small" label-width="80px" :rules="dlg.rules" :model="dlg.form">
				<el-form-item label="姓名" prop="name">
					<el-input placeholder="姓名" autocomplete="off" maxlength="10" v-model="dlg.form.name"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="username">
					<el-input placeholder="用户名" autocomplete="off" maxlength="10"
						v-model="dlg.form.username"></el-input>
				</el-form-item>

				<el-collapse>
					<el-collapse-item title="高级设置" name="1">
						<div class="hint">
							<div class="txt">以下内容请联系系统管理员进行修改</div>
							<div><label>角色</label><span>{{ my.user.roleName }}</span></div>
							<div><label>数据权限</label><span>{{ my.user.roleType === 0 ? '本人患者' : '全科患者'}}</span></div>
							<div>
								<label>科室</label>
								<div class="hint-content">
									<span style="margin-right:15px;" v-for="item in my.user.depList"
										:key="item.id">{{ item.depName }}</span>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading" @click="saveForm">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog custom-class="relative" title="修改密码" width="500px" center :visible.sync="dlg.active2"
			:close-on-click-modal="false">
			<el-form ref="form2" size="small" label-width="80px" :rules="dlg.rules" :model="dlg.form2">
				<el-form-item label="密码" prop="newPwd">
					<el-input type="password" placeholder="密码" autocomplete="off" v-model="dlg.form2.newPwd"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="repeat">
					<el-input type="password" placeholder="确认密码" autocomplete="off"
						v-model="dlg.form2.repeat"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading" @click="saveForm2">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog custom-class="callerDlg" title="来电号码" width="662px" center :visible.sync="dlg.callerAct"
			:close-on-click-modal="false">
			<h2>{{ callerMsg.phone}}</h2>
			<div v-if="callerMsg?.phoneList.length>0">
				<p>此电话查询到以下患者</p>
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="callerMsg.phoneList" v-loading="isLoading">
					<el-table-column prop="patientName" label="关联患者"></el-table-column>
					<el-table-column prop="relationship" label="关系">
						<template slot-scope="scope">
							<span>
								{{
									{
										0:'本人',
										1:'父亲',
										2:'母亲',
										3:'子女',
										4:'其他亲属',
									}[scope.row.relationship]
								}}
							</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip :content="(status=='finished') ?'绑定患者':'查看'" placement="top"
									:enterable="false">
									<i @click="openPatientUser(scope.row)"
										:class="status=='finished'?'el-icon-connection':'icon-research'"></i>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="noQuery" v-else>未查询任何患者</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog custom-class="relative" width="500px" title="温馨提示" center :visible.sync="dlg.uploadAct"
			:close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
			<div style="font-size: 22px;text-align: center;">上传文件中.请勿关闭页面</div>
		</el-dialog>
		<el-dialog custom-class="relative" width="500px" title="温馨提示" center :visible.sync="dlg.authorizeAct"
			:close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
			<div style="font-size: 22px;text-align: center;color: red;">{{authorizeTips}}</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round @click="closeDlg">我知道了</el-button>
				<el-button size="mini" type="primary" round @click="toMydata">查看详情</el-button>
			</div>
		</el-dialog>

		
		<Knowledge :visible="dlg.active3" @close="closeDlg" />
		<ClearCache v-if="dlg.clearCacheAct"/>

	</div>
</template>

<script>
	import api from '../../../service/api';
	import Knowledge from '@/components/Knowledge/Knowledge.vue';
	import Ring from './components/ring.vue';
	import telMixins from './telMixins.js';
	import {
		EventBus
	} from '@/event-bus.js';
	import ClearCache from '@/components/ClearCache/index.vue'

	export default {
		components: {
			Ring,
			Knowledge,
			ClearCache
		},
		mixins: [telMixins],
		data() {
			let validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.dlg.form2.newPwd) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
					if (regex.test(value)) {
						callback();
					} else {
						callback(new Error('密码必须包含大小写字母、符号和数字，且长度至少为8个字符'));
					}
				}
			};
			return {
				isLoading: false,
				dlg: {
					// 账号管理
					active: false,
					// 密码管理
					active2: false,
					// 知识库
					active3: false,
					//来电显示
					callerAct: false,
					// 上传文件全屏遮罩
					uploadAct: false,
					authorizeAct:false,
					// 清理缓存
					clearCacheAct:false,
					rules: {
						name: {
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
						username: {
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
						newPwd: {
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
						repeat: {
							required: true,
							validator: validatePass,
							trigger: 'blur'
						},
					},
					form: {
						name: undefined,
						username: undefined,
						roleId: 0
					},
					form2: {},
				},
				pop: {
					active: false
				},
				callerMsg: {
					phone: '',
					phoneList: []
				},
				tips: '',
				status: '',
				callstate: '',
				smsCount: {},
				hospitalCode: 'YS_HM4',
				UboxCallFlag: false,
				smsFlag: false,
				GXcallFlag: false,
				authorizeTips:'',
				version:'',
				my:{}
			}
		},
		async created() {
			this.my = this.getUser();
			// this.my.user = {};
			this.dlg.form.id = this.my.user.id;
			this.dlg.form.name = this.my.name;
			this.dlg.form.username = this.my.username;
			this.dlg.form.roleId = this.my.user.roleId;
			this.UboxCallFlag=await api.getUboxCallFlag();
			this.smsFlag=await api.getSmsFlag();
			if(this.smsFlag){
				this.loadList();
			}
			this.GXcallFlag=await api.getGXcallFlag()

		},
		async mounted() {
			document.addEventListener('visibilitychange', this.handleVisiable);

			let r = JSON.parse(localStorage.getItem('route'));
			EventBus.$on('update-phoneList-value', (newValue) => {
				this.callerMsg = newValue;
				if (newValue && this.$route.fullPath === r) { //
					// this.callstate=c;
					this.callstate = newValue;
				}
				if (newValue.phone !== '') {
					this.dlg.callerAct = true;
				}
			});
			EventBus.$on('update-callstatus', (newVal) => {
				this.status = newVal;
				if (newVal == 'uploading') {
					this.dlg.uploadAct = true
				} else if (newVal == 'finished') {
					this.dlg.uploadAct = false;
					this.$nextTick(() => {
						this.callstate = '';
					})
				} else if (newVal == 'unServe' || newVal == 'unUsb' || newVal == 'normal') {
					this.tips = newVal;
					this.callstate = '';
				}
				this.update()
				// console.log(this.status,'---------stat',this.callstate);
			});
			let info = JSON.parse(localStorage.getItem('callerInfo'));
			if (info) {
				this.callerMsg.phone = info.split(',')[0];
			}
			let c = localStorage.getItem('callState');
			if (c && this.$route.fullPath === r) { //
				this.callstate = c;
			}
			let s = JSON.parse(localStorage.getItem('callstatus'));
			this.status = s
			// console.log(c, info, s, '=======crinfo====mounted===', this.status);

			// document.removeEventListener('visibilitychange', this.handleVisiable);
			let hospitalCode = JSON.parse(localStorage.getItem('hospitalCode'));
			if (!hospitalCode) {
				this.hospitalCode = api.getHospitalCode().then((res) => {
					localStorage.setItem('hospitalCode', JSON.stringify(res));
				})
			}
			if (this.smsFlag) {
				this.loadList();
			}
			this.checkAuthorize();
			
			
		},
		destroyed() {
			document.removeEventListener("visibilitychange", this.handleVisiable);
		},
		methods: {
			handleVisiable(){
	this.my = this.getUser();
			},
			async loadList() {
				this.isLoading = true;
				let res = await api.getSmsCountList({
					pageNumber: 1,
					pageSize: 20
				});
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				this.smsCount = res.data;
				localStorage.setItem('smsInfo', JSON.stringify(res.data))
				this.isLoading = false;
			},
			getUser() {
				return JSON.parse(localStorage.getItem('user')).data;
			},
			update() {
				let info = JSON.parse(localStorage.getItem('callerInfo'));
				if (info) {
					this.callerMsg.phone = info.split(',')[0];
				} else {
					this.callerMsg = {
						phone: '',
						phoneList: []
					};
				}
				let c = localStorage.getItem('callState');
				let r = JSON.parse(localStorage.getItem('route'));

				if (c && this.$route.fullPath === r) { //
					this.callstate = c;
				}
				// console.log(c,r,info,'======crinfo=====update===');
			},
			// handleVisiable(e){/// 看看有没有用
			// 	if(e.target.visibilityState == "visible"){
			// 		let info=JSON.parse(localStorage.getItem('callerInfo'));
			// 		if(info){
			// 			console.log(88888888888888);
			// 			this.callerMsg.phone=info.split(',')[0];
			// 		}
			// 	}
			// },
			// 无转评价
			hangupHandle() {
				let save = JSON.parse(localStorage.getItem('save'));
				let callState = localStorage.getItem('callState');
				console.log(save, '--------', callState, this.callerMsg.phoneList);
				if (callState == 'callout' || this.callerMsg.phoneList.length == 0 || (callState == 'callIn' && save ==
						'saved')) {

					localStorage.removeItem('callerInfo');
					localStorage.removeItem('callState');
					localStorage.removeItem('route');
					localStorage.removeItem('phoneRecordId');
					setTimeout(() => {
						localStorage.removeItem('save');
					}, 1000);
				}
				this.statusHandle('finished')
			},
			//加遂昌转评价功能
			clearState() {
				let user = JSON.parse(localStorage.getItem('user')).data;
				this.callerMsg = {
					phone: '',
					phoneList: []
				};
				this.callstate = '';
				this.status = '';
				localStorage.removeItem('callerInfo');
				localStorage.removeItem('tips');
				localStorage.removeItem('callState');
				localStorage.removeItem('phoneRecordId');
				localStorage.removeItem('callstatus');
				localStorage.removeItem('route');
				// localStorage.removeItem('save');
				if (this.UboxCallFlag && (user.user.roleId == '4' || user.user.roleId =='6'|| user.user.roleId =='1')) { //||this.hospitalCode=='YS_HM4'
					let h = localStorage.getItem('hdl')
					console.log(window.hdl, '======hdl', h);
					window.ubox_StopRecord(h);
					setTimeout(() => {
						window.uboxInit(this.callBack, this.callerHandle, this.statusHandle); //电话盒子呼叫
					}, 3000);
				} else if (this.GXcallFlag && (user.user.roleId == '4' || user.user.roleId =='6'|| user.user.roleId =='1')) { //||this.hospitalCode=='YS_HM4'  //遂昌转评价功能
					if (window.websocket) {
						this.dropCall(window.staffNo);
					}
					setTimeout(() => {
						this.callInit();
					}, 300);
				}
				this.statusHandle('finished')
			},
			togglePop() {
				this.pop.active = !this.pop.active;
			},
			logout() {
				this.clearState();
				localStorage.setItem('user', '');
				this.$router.push({
					name: 'Login'
				});
			},
			showDlg(v) {
				switch (v) {
					case 1:
						this.dlg.active = true;
						break;
					case 2:
						this.dlg.active2 = true;
						break;
					case 3:
						this.dlg.active3 = true;
						break;
					case 4:
						this.openCallInDlg();
						break;
				}
			},
			closeDlg() {
				this.dlg.active = false;
				this.dlg.active2 = false;
				this.dlg.active3 = false;
				this.dlg.callerAct = false;
				this.dlg.authorizeAct = false;

			},
			openCallInDlg() {
				let info = JSON.parse(localStorage.getItem('callerInfo'));
				if (info) {
					this.callerHandle(info.split(',')[0], info.split(',')[1])
				}
				// else {
				// 	// 模拟打电话流程
				// 	window.Ubox_CallId('2050','17600616165');
				// }
			},
			saveForm() {
				// let res;
				this.$refs['form'].validate(async (valid) => {
					if (valid) {
						this.isLoading = true;
						this.dlg.form2.id = this.my.user.id;
						let res = await api.editUser(this.dlg.form);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.$message.success('保存成功');
						this.closeDlg();

						this.my.name = this.dlg.form.name;
						let newUser = JSON.parse(localStorage.getItem('user'));
						newUser.data.username = this.dlg.form.username;
						newUser.data.name = this.dlg.form.name;
						localStorage.setItem('user', JSON.stringify(newUser));
					}
				});
			},
			saveForm2() {
				this.$refs['form2'].validate(async (valid)=>{
					if (valid) {
						this.isLoading = true;
						this.dlg.form2.id = this.my.user.id;
						let res = await api.editUserPassword(this.dlg.form2);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.$message.success('修改成功，请使用新密码重新登录');
						this.logout();
					}
				});			
			},
			async openPatientUser(item) {
				if (this.status == 'finished') {
					let phoneRecordId = JSON.parse(localStorage.getItem('phoneRecordId'));
					let res = await api.updatePatientRecord({
						phoneRecordId: phoneRecordId,
						patientId: item.patientId,
						phone: this.callerMsg.phone
					})
					this.clearState();
					this.callInit();
					this.closeDlg();
				} else {
					this.closeDlg();
					window.open(`#/patient/user?patientId=${item.patientId}&t=2`);
				}
			},
			async checkAuthorize(){
				this.version=await api.getHospitalVersion()
				console.log(this.version,'======vv')
				// 检测授权
				let res = await api.checkAuthorize();
				if (res.code == '6001') {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				
				if (res.code == '6002' && (this.my.user.roleId == '4' || this.my.user.roleId == '6'  || this.my.user.roleId == '7' )) {
					this.authorizeTips = res.message;
					this.dlg.authorizeAct = true;
				}
				// else if(res.code==1000){
				// 	if(res.data!==this.version){
				// 		this.dlg.clearCacheAct=true;
				// 	}
				// }
			},
			toMydata(){
				this.closeDlg();
				this.$router.push({name:'System/Info'})
			},
		}
	}
</script>

<style lang="less" scoped>

	.navbar {
		height: 60px;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		display: flex;

		.leftbox {
			display: flex;
			align-items: center;

			.callerbox {
				cursor: pointer;
				display: flex;
				align-items: center;

				p {
					margin-left: 16px;
					width: auto;
					height: 35px;
					border-radius: 21px;
					line-height: 35px;
					text-align: center;
					background: #31D44B;
					padding: 0 16px;

					span {
						font-size: 18px;
						font-weight: bolder;
						margin-right: 32px;
					}
				}
			}

			.callingBox,
			.tipsBox,
			.clearState,
			.smstips {
				width: auto;
				height: 35px;
				border-radius: 8px;
				line-height: 35px;
				text-align: center;
				padding: 0 16px;
				font-size: 18px;
				margin-left: 32px;
			}

			.tipsBox,
			.smstips {
				background: #F56C6C;
			}

			.callingBox {
				background: #FFC247;
			}

			.clearState {
				background: #F56C6C;
				cursor: pointer;
			}
		}

		.rigbox {
			display: flex;
			.logout{
				padding-right: 4px;
			}
			>.item {
				position: relative;
				padding-left: 25px;
				align-items: center;
				display: flex;

				&.more {
					padding: 20px;
					cursor: pointer;
					z-index: 3;
				}

				.is-dot {
					width: 5px;
					height: 5px;
					border: none;
				}
			}
		}

		&.active {
			.item.more {
				color: #333;
			}

			.pop-mask {
				display: block;
			}

			.pop {
				display: block;
			}
		}

		.hint {
			>div {
				display: flex;
			}

			.txt {
				font-size: 12px;
				color: #858585;
			}

			label {
				width: 100px;
				text-align: center;
				display: inline-block;
			}

			.hint-content {
				flex: 1;
			}
		}

		.nick {
			max-width: 80px;
			height: 22px;
			padding-left: 5px;
			cursor: pointer;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.pop {
			position: absolute;
			top: 58px;
			right: 20px;
			width: 160px;
			padding: 10px 0;
			box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
			background: #fff;
			text-align: center;
			z-index: 2;
			display: none;

			>div {
				padding: 10px 0;
			}
		}

		::v-deep .el-table .el-table__cell {
			text-align: center !important;
		}

		::v-deep .callerDlg {
			.noQuery {
				margin-top: 18px;
				font-size: 18px;
				font-weight: 500;
				text-align: center;
			}

			.el-dialog__body {
				padding: 6px 25px 30px;

				h2 {
					margin: 0 auto;
					font-size: 24px;
					font-weight: bolder;
					color: #699CE4;
					text-align: center;
				}

				p {
					text-align: center;
				}
			}
		}
	}
</style>